import { Button, Checkbox, Col, Form, Input, Row } from "antd";
import authApi from "api/authApi";
import BannerSignIn from "assets/images/banner/banner-sign-in.png";
import clsx from "clsx";
import { AppInput } from "components/input";
import { KHCN_LOGO, VBC_LOGO_DARK } from "constants/images";
import { useFormik } from "formik";
import { openAlert } from "state/alert/alertSlice";
import { useAppDispatch } from "state/hooks";
import { closeLoading, openLoading } from "state/loading/loadingSlice";
import { saveInfo } from "state/userInfo/userInfoSlice";
import * as Yup from "yup";

const CryptoJS = require("crypto-js");

const SignInPage = () => {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      phone: "",
      password: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string().required("Thông tin bắt buộc!"),
      password: Yup.string().required("Thông tin bắt buộc"),
    }),
    onSubmit: (values) => {
      handleSignIn(values);
    },
  });

  const handleSignIn = async (values: { phone: string; password: string }) => {
    dispatch(
      openLoading({
        title: "Xin vui lòng chờ trong giây lát",
      }),
    );
    try {
      const { phone, password } = values;
      const hashedPassword = CryptoJS.SHA256(password).toString();
      const response = await authApi.login({
        phone,
        password: hashedPassword,
      });
      if (response?.data?.errorCode === 1 && response.data.data?.token) {
        dispatch(
          saveInfo({
            token: response.data.data.token,
          }),
        );
        dispatch(closeLoading());
      } else {
        dispatch(closeLoading());
        dispatch(
          openAlert({
            type: "error",
            title: "Đăng nhập thất bại, xin vui lòng thử lại",
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "Đóng",
          }),
        );
      }
    } catch (error) {
      dispatch(closeLoading());
      dispatch(
        openAlert({
          type: "error",
          title: "Đăng nhập thất bại, xin vui lòng thử lại",
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: "Đóng",
        }),
      );
    }
  };

  return (
    <div className="h-screen">
      <Row gutter={[0, 0]} className="h-full">
        <Col xs={0} sm={0} md={0} lg={10} xxl={8}>
          <div className="bg-primary h-full relative">
            <div className="absolute left-0 top-[50%] translate-y-[-50%] lg:w-[calc(100%+20px)] 2xl:lg:w-[calc(100%+60px)] z-10">
              <img src={BannerSignIn} alt="" className="w-full" />
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={14} xxl={16} className="relative">
          <div className="absolute top-0 bottom-0 right-0 left-[-20px] h-full rounded-l-3xl bg-white">
            <div className="m-auto flex flex-col items-center justify-center h-full">
              <div className="w-full max-w-[80%] md:max-w-[60%] lg:max-w-[50%] 2xl:max-w-[40%] flex-1">
                <div className="w-full flex-1 h-full flex flex-col items-center justify-center">
                  <div className="flex items-start">
                    <img src={KHCN_LOGO} alt="" className="h-[44px] 2xl:h-[50px]" />
                    <h1 className="text-center lg:text-md 2xl:text-lg font-bold ml-3">
                      SỞ KHOA HỌC VÀ CÔNG NGHỆ <br /> THÀNH PHỐ HỒ CHÍ MINH
                    </h1>
                  </div>
                  <h1 className="text-primary font-black text-lg lg:text-xl 2xl:text-2xl my-6 lg:mt-7 lg:mb-14 text-center 2xl:leading-relaxed">
                    XÁC THỰC CHỨNG NHẬN <br />
                    ỨNG DỤNG CÔNG NGHỆ BLOCKCHAIN
                  </h1>
                  <h4 className="text-xl 2xl:text-2xl font-bold mb-6">Đăng nhập</h4>
                  <Form layout="vertical" className="self-stretch">
                    <Form.Item label="Email / Số điện thoại">
                      <AppInput
                        placeholder="email@example.com"
                        invalid={Boolean(formik.touched.phone && formik.errors.phone)}
                        invalidText={formik.errors.phone}
                        {...formik.getFieldProps("phone")}
                      />
                    </Form.Item>
                    <Form.Item label="Mật khẩu">
                      <Input.Password
                        className={clsx("input input-outline input-outline-primary", {
                          valid: formik.values.password && !formik.errors.password,
                          invalid: formik.touched.password && formik.errors.password,
                        })}
                        {...formik.getFieldProps("password")}
                      />
                      {formik.touched.password && formik.errors.password && (
                        <p className="text-xs mt-2 text-danger">{formik.errors.password}</p>
                      )}
                    </Form.Item>
                    <Form.Item label="">
                      <Checkbox checked className="checkbox checkbox-primary">
                        Ghi nhớ đăng nhập
                      </Checkbox>
                    </Form.Item>
                    <Form.Item label="" className="mb-3">
                      <Button onClick={formik.submitForm} className="btn btn-primary px-6 py-3 w-full">
                        Đăng nhập
                      </Button>
                    </Form.Item>
                  </Form>
                  <p className="text-sm 2xl:text-md text-dark">
                    Bạn chưa có tài khoản? <span className="text-primary opacity-40">Đăng ký ngay</span>
                  </p>
                </div>
              </div>
              <div className="bg-white py-5 text-dark text-sm flex items-center justify-center">
                <div className="flex items-center flex-wrap text-2xs lg:text-xs 2xl:text-sm">
                  <p className="mr-1">© Công ty Cổ phần Vietnam Blockchain 2024. Đã đăng ký bản quyền</p>
                </div>
                <img src={VBC_LOGO_DARK} alt="" width={100} height={40} className="ml-1 2xl:ml-2" />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignInPage;
